<script setup>
const props = defineProps({
  actionUrl: {
    type: String,
  },
  data: {
    type: Object,
  },
})

const { t } = useI18n()
</script>

<template>
  <DSAlert
    type="warning"
    no-close
  >
    <i18n-t keypath="Your {membershipName} is missing a payment method">
      <template #membershipName>
        <span>{{ props.data.membership.name }}</span>
      </template>
    </i18n-t>
    <template #cta>
      <BaseLink
        :url="props.actionUrl"
        :v2-link="false"
        :apply-current-provider-prefix="false"
        class="btn-sm text-center text-sm font-400 uppercase lt-sm:w-full btn-outline-secondary"
      >
        {{ t('Add Payment Details') }}
      </BaseLink>
    </template>
  </DSAlert>
</template>

<i18n>
{
  "en-us": {
    "Your {membershipName} is missing a payment method": "Your {membershipName} is missing a payment method",
    "Add Payment Details": "Add Payment Details"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Your {membershipName} is missing a payment method": "Ihrer {membershipName} fehlt eine Zahlungsmethode.",
  "Add Payment Details": "Zahlungsdetails hinzufügen"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Your {membershipName} is missing a payment method": "Il manque un mode de paiement à votre {membershipName}",
  "Add Payment Details": "Ajouter des informations de paiement"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Your {membershipName} is missing a payment method": "Su {membershipName} no tiene método de pago",
  "Add Payment Details": "Añadir información de pago"
}
</i18n>
